import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { useNavigate, useParams } from "react-router";
import { connect, useDispatch } from "react-redux";
import { applicationDetail } from "../../actions/v3/applicationDetail";
import jsPDF from "jspdf";
import robotoLight from "../../helpers/fonts/robotoLight";
import robotoBold from "../../helpers/fonts/robotoBold";
import {
  concludeApplication,
  resetConcludeApplication
} from "../../actions/v3/concludeApplication";
import Swal from "sweetalert2";
import logo from "../../helpers/onedose_black.png";
import {
  resetSaveApplicationResult,
  saveApplicationResult
} from "../../actions/application/saveApplicationResult";
import { lastApplicationResult } from "../../actions/application/lastApplicationResult";
import Breadcrumb from "./components/Breadcrumb";
import ModalPreview from "./components/ModalPreview";
import QuestionInput from "./components/QuestionInput";
import dayjs from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import TextArea from "./components/TextArea";

function CreateApplicationReport(props) {
  const { Id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [base64Pdf, setBase64Pdf] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const [about, setAbout] = useState("");
  const [patientMedicalHistory, setPatientMedicalHistory] = useState("");
  const [informationOnDisease, setInformationOnDisease] = useState("");
  const [doctorsOpinion, setDoctorsOpinion] = useState("");
  const [patientQuestions, setPatientQuestions] = useState(null);
  const [recommendedLinks, setRecommendedLinks] = useState("");
  const [isSave, setIsSave] = useState(false);
  const [soruCevapYorumlar, setSoruCevapYorumlar] = useState([]);
  const [patientNameSurname, setPatientNameSurname] = useState("");
  const [applicationProfession, setApplicationProfession] = useState("");
  const [createdAt, setcreatedAt] = useState("");
  const [doctorNameSurname, setDoctorNameSurname] = useState("");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [labAnomalies, setLabAnomalies] = useState("");
  const [radyolojiAnomalies, setRadyolojiAnomalies] = useState("");
  const now = Date();

  useEffect(() => {
    dispatch(applicationDetail(Id));
    dispatch(lastApplicationResult(Id));
  }, [dispatch, Id]);

  useEffect(() => {
    if (props.lastApplicationResult.done) {
      if (props.lastApplicationResult.lastApplicationResult.result != null) {
        const data = JSON.parse(
          props.lastApplicationResult?.lastApplicationResult?.result?.data ||
            "{}"
        );
        setAbout(data?.about);
        setPatientMedicalHistory(data?.patientMedicalHistory);
        setInformationOnDisease(data?.informationOnDisease);
        setDoctorsOpinion(data?.doctorsOpinion);
      }
    }
  }, [props.lastApplicationResult]);

  useEffect(() => {
    if (props.concludeApplication.done) {
      Swal.fire({
        title: "Rapor oluşturuldu!",
        text: "Rapor başarıyla oluşturuldu ve başvuru sonlandırıldı. Ana sayfaya yönlendiriliyorsunuz.",
        icon: "success"
      }).then(() => {
        resetConcludeApplication();
        navigate(`/dashboard`);
      });
    }
  }, [props.concludeApplication]);

  useEffect(() => {
    if (props.saveApplicationResult.done) {
      setIsSave(true);
    }
  }, [props.saveApplicationResult]);

  useEffect(() => {
    if (props.applicationDetail.done) {
      const data =
        props.applicationDetail?.applicationDetail?.result?.survey?.data;
      if (data) {
        const parsedData = JSON.parse(data || "{}");
        setPatientQuestions(parsedData["Görüş Almak İstediğiniz Konu"]);
        setPatientNameSurname(
          `${
            props.applicationDetail?.applicationDetail?.result
              ?.applicationRepresentedPerson
              ? props.applicationDetail?.applicationDetail?.result
                  ?.applicationRepresentedPerson?.name +
                " " +
                props.applicationDetail?.applicationDetail?.result
                  ?.applicationRepresentedPerson?.surname
              : props.applicationDetail?.applicationDetail?.result
                  ?.applicationOwnerUser?.name +
                " " +
                props.applicationDetail?.applicationDetail?.result
                  ?.applicationOwnerUser?.lastName
          }`
        );
        setApplicationProfession(
          parsedData["Görüş Almak İstediğiniz Uzmanlık Alanı"]
        );
      }
      setDoctorNameSurname(`${user.name} ${user.lastName}`);
      setcreatedAt(props.applicationDetail.applicationDetail.result.createdAt);
    }
  }, [props.applicationDetail]);

  useEffect(() => {
    if (patientQuestions) {
      const initialData = Object.entries(patientQuestions).map(
        ([soru, cevap]) => ({
          soru,
          cevap,
          doktorYorumu: ""
        })
      );
      setSoruCevapYorumlar(initialData);
    }
  }, [patientQuestions]);

  const handleYorumChange = (index, event) => {
    const yeniSoruCevapYorumlar = [...soruCevapYorumlar];
    yeniSoruCevapYorumlar[index].doktorYorumu = event.target.value;
    setSoruCevapYorumlar(yeniSoruCevapYorumlar);
  };

  const generatePdf = async () => {
    const pdf = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a4"
    });

    pdf.addFileToVFS("Roboto-Regular.ttf", robotoLight);
    pdf.addFileToVFS("Roboto-Bold.ttf", robotoBold);
    pdf.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    pdf.addFont("Roboto-Bold.ttf", "Roboto", "bold");

    const maxWidth = 500;
    const lineSpacing = 20;
    const marginTop = 150;
    const initialContentStartY = 230;
    let contentStartY = initialContentStartY;

    const footerImage = "/assets/images/esigned.png";

    const addFooterImage = (boxX, boxY, boxWidth, boxHeight) => {
      const imageWidth = 30; // Görselin genişliği
      const imageHeight = 30; // Görselin yüksekliği
      const imageX = boxX + boxWidth - imageWidth - 10; // Kutunun sağ kenarından 10 birim boşluk
      const imageY = boxY + boxHeight - imageHeight - 10; // Kutunun alt kenarından 10 birim boşluk
    
      // Görseli kutunun içine ekle
      pdf.addImage(footerImage, "PNG", imageX, imageY, imageWidth, imageHeight);
    
      // Dinamik applicationId
      const applicationId =
        props.applicationDetail?.applicationDetail?.result?.survey?.applicationId;
    
      // ApplicationId metni koordinatları
      const textX = imageX; // Görselin sol kenarına hizalanır
      const textY = imageY + imageHeight + 6; // Görselin hemen altına 6 birim boşluk bırak
    
      // ApplicationId'yi yaz
      pdf.setFontSize(6); // Küçük bir yazı boyutu ayarla
      pdf.text(applicationId, textX - 72, textY);
    };
    

    const addHeader = () => {
      pdf.addImage(logo, "PNG", 40, 16, 50, 32, "", "FAST");
  
      const watermarkImg = "/assets/images/facilities/ercitip.png";
      const watermarkWidth = pdf.internal.pageSize.getWidth() / 2;
      const watermarkHeight = pdf.internal.pageSize.getHeight() / 3;
      const watermarkX =
          (pdf.internal.pageSize.getWidth() - watermarkWidth) / 2;
      const watermarkY =
          (pdf.internal.pageSize.getHeight() - watermarkHeight) / 2;
  
      pdf.addImage(
          watermarkImg,
          "PNG",
          watermarkX,
          watermarkY,
          watermarkWidth,
          watermarkHeight,
          "",
          "FAST"
      );
  
      pdf.setFontSize(14);
      pdf.setFont("Roboto", "bold");
      pdf.text(
          "ERCİYES ÜNİVERSİTESİ TIP FAKÜLTESİ HASTANELERİ",
          pdf.internal.pageSize.getWidth() / 2,
          30,
          { align: "center" }
      );
      pdf.text(
          "İKİNCİ GÖRÜŞ RAPORU",
          pdf.internal.pageSize.getWidth() / 2,
          50,
          { align: "center" }
      );
  
      pdf.setFontSize(10);
      pdf.setFont("Roboto", "normal");
      pdf.text(
          `${dayjs(now).format("DD/MM/YYYY")}`,
          pdf.internal.pageSize.getWidth() - 100,
          67
      );
  
      const boxX = 40;
      const boxY = 70;
      const boxWidth = 510;
      const boxHeight = 130;
  
      pdf.setFontSize(12);
      pdf.setFont("Roboto", "normal");
      pdf.rect(boxX, boxY, boxWidth, boxHeight);
  
      let infoContentY = boxY + 20;
      const infoContentX = boxX + 10;
      const lineHeight = 30;
  
      pdf.setFont("Roboto", "bold");
      pdf.text(`Hasta Adı Soyadı:`, infoContentX, infoContentY);
      pdf.setFont("Roboto", "normal");
      pdf.text(`${patientNameSurname}`, infoContentX + 130, infoContentY);
  
      infoContentY += lineHeight;
      pdf.setFont("Roboto", "bold");
      pdf.text(`Bölüm:`, infoContentX, infoContentY);
      pdf.setFont("Roboto", "normal");
      pdf.text(`${applicationProfession}`, infoContentX + 130, infoContentY);
  
      infoContentY += lineHeight;
      pdf.setFont("Roboto", "bold");
      pdf.text(`Doktor:`, infoContentX, infoContentY);
      pdf.setFont("Roboto", "normal");
      pdf.text(`${doctorNameSurname}`, infoContentX + 130, infoContentY);
  
      infoContentY += lineHeight;
      pdf.setFont("Roboto", "bold");
      pdf.text(`Başvuru Tarihi:`, infoContentX, infoContentY);
      pdf.setFont("Roboto", "normal");
      pdf.text(
          `${dayjs(createdAt).format("DD/MM/YYYY")}`,
          infoContentX + 130,
          infoContentY
      );
  
      addFooterImage(boxX, boxY, boxWidth, boxHeight);
  
      // Yeni sayfa eklenirken font ve yazı boyutu sıfırlanmasın.
      pdf.setFont("Roboto", "normal");
      pdf.setFontSize(12);
  
      contentStartY = initialContentStartY;
  };
  
    const addContent = (content) => {
      const pageHeight = pdf.internal.pageSize.getHeight();

      if (Array.isArray(content)) {
        content.forEach((item) => {
          if (item.cevap) {
            const soruLines = pdf.splitTextToSize(item.soru, maxWidth);
            pdf.setFont("Roboto", "bold");
            soruLines.forEach((line) => {
              if (contentStartY + lineSpacing > pageHeight) {
                pdf.addPage();
                addHeader();
                contentStartY = initialContentStartY;
              }
              pdf.text(line, 40, contentStartY);
              contentStartY += lineSpacing;
            });

            pdf.setFont("Roboto", "bold");
            if (contentStartY + lineSpacing > pageHeight) {
              pdf.addPage();
              addHeader();
              contentStartY = initialContentStartY;
            }
            pdf.text("Cevap:", 40, contentStartY);
            pdf.setFont("Roboto", "normal");
            contentStartY += lineSpacing;
            const cevapLines = pdf.splitTextToSize(item.cevap, maxWidth);
            cevapLines.forEach((line) => {
              if (contentStartY + lineSpacing > pageHeight) {
                pdf.addPage();
                addHeader();
                contentStartY = initialContentStartY;
              }
              pdf.text(line, 40, contentStartY);
              contentStartY += lineSpacing;
            });

            if (item.doktorYorumu) {
              pdf.setFont("Roboto", "bold");
              if (contentStartY + lineSpacing > pageHeight) {
                pdf.addPage();
                addHeader();
                contentStartY = initialContentStartY;
              }
              pdf.text("Doktor yorumu: ", 40, contentStartY);
              pdf.setFont("Roboto", "normal");
              contentStartY += lineSpacing;
              const yorumLines = pdf.splitTextToSize(
                item.doktorYorumu,
                maxWidth
              );
              yorumLines.forEach((line) => {
                if (contentStartY + lineSpacing > pageHeight) {
                  pdf.addPage();
                  addHeader();
                  contentStartY = initialContentStartY;
                }
                pdf.text(line, 40, contentStartY);
                contentStartY += lineSpacing;
              });
            }
          }
        });
      } else {
        const contentLines = pdf.splitTextToSize(content, maxWidth);
        contentLines.forEach((line) => {
          if (contentStartY + lineSpacing > pageHeight) {
            pdf.addPage();
            addHeader();
            contentStartY = initialContentStartY;
          }
          pdf.text(line, 40, contentStartY);
          contentStartY += lineSpacing;
        });
      }
    };

    const addSection = (content, title) => {
      const pageHeight = pdf.internal.pageSize.getHeight();

      if (contentStartY + 30 > pageHeight) {
        pdf.addPage();
        addHeader();
        contentStartY = initialContentStartY;
      }

      pdf.setFontSize(12);
      pdf.setFont("Roboto", "bold");
      pdf.text(title, 40, contentStartY);
      contentStartY += 20;

      pdf.setFont("Roboto", "normal");
      addContent(content);
    };

    const addHtmlContent = async (htmlContent, title) => {
      const pageHeight = pdf.internal.pageSize.getHeight();

      if (contentStartY + 30 > pageHeight) {
        pdf.addPage();
        addHeader();
        contentStartY = initialContentStartY;
      }

      pdf.setFontSize(12);
      pdf.setFont("Roboto", "bold");
      pdf.text(title, 40, contentStartY);
      contentStartY += 20;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = "absolute";
      tempDiv.style.top = "-9999px";
      tempDiv.style.fontSize = "12px";
      tempDiv.style.fontFamily = "Roboto";
      tempDiv.style.width = `${maxWidth}px`;
      document.body.appendChild(tempDiv);

      const processNode = (node, isBold) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const textLines = pdf.splitTextToSize(
            node.nodeValue.trim(),
            maxWidth
          );
          textLines.forEach((line) => {
            if (contentStartY + lineSpacing > pageHeight) {
              pdf.addPage();
              addHeader();
              contentStartY = initialContentStartY;
            }
            pdf.setFont("Roboto", isBold ? "bold" : "normal");
            pdf.text(line, 40, contentStartY);
            contentStartY += lineSpacing;
          });
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const newIsBold =
            isBold ||
            node.style.fontWeight === "bold" ||
            node.tagName === "B" ||
            node.tagName === "STRONG";
          node.childNodes.forEach((child) => processNode(child, newIsBold));
        }
      };

      tempDiv.childNodes.forEach((child) => processNode(child, false));
      document.body.removeChild(tempDiv);
    };

    addHeader();
    await addHtmlContent(about, "DOKTOR ÖZGEÇMİŞ");
    await addHtmlContent(patientMedicalHistory, "TIBBİ ÖYKÜ");
    await addHtmlContent(radyolojiAnomalies, "RADYOLOJİK ANOMALİLERİ");
    await addHtmlContent(labAnomalies, "LABORATUVAR ANOMALİLERİ");
    addSection(soruCevapYorumlar, "HASTA SORULARI");
    await addHtmlContent(
      informationOnDisease,
      "DANIŞILAN HASTALIK VEYA DURUMLA İLGİLİ GENEL BİLGİLER"
    );
    await addHtmlContent(doctorsOpinion, "DOKTOR YORUM VE ÖNERİLERİ");

    if (recommendedLinks) {
      pdf.addPage();
      addHeader();
      pdf.setFont("Roboto", "bold");
      pdf.setFontSize(12);
      pdf.text("ÖNERİLEN LİNKLER", 40, contentStartY);
      pdf.setFont("Roboto", "normal");
      pdf.setFontSize(12);
      const linkLines = pdf.splitTextToSize(recommendedLinks, maxWidth);
      let linkStartY = contentStartY + 20;
      linkLines.forEach((line) => {
        if (linkStartY + lineSpacing > pdf.internal.pageSize.getHeight()) {
          pdf.addPage();
          addHeader();
          linkStartY = initialContentStartY;
        }
        pdf.text(line, 40, linkStartY);
        linkStartY += lineSpacing;
      });
    }

    return pdf;
  };

  const handlePreviewReport = async () => {
    const pdf = await generatePdf();
    const pdfAsBase64 = pdf.output("datauristring");
    setBase64Pdf(pdfAsBase64);
    setIsPreviewModalOpen(true);
  };

  const handleCreateReport = async () => {
    const pdf = await generatePdf();
    const pdfAsBase64 = pdf.output("datauristring");
    await cApplication(pdfAsBase64);
  };

  async function cApplication(base64Pdf) {
    dispatch(concludeApplication(Id, base64Pdf));
  }

  function handleSaveReport() {
    if (!doctorsOpinion || doctorsOpinion.trim() === "") {
      Swal.fire({
        title: "Eksik Bilgi!",
        text: "Lütfen doktor yorum ve önerileri alanını doldurun.",
        icon: "warning",
        confirmButtonText: "Tamam"
      });
      return;
    }

    const data = {
      about,
      patientMedicalHistory,
      informationOnDisease,
      doctorsOpinion,
      recommendedLinks,
      soruCevapYorumlar,
      labAnomalies,
      radyolojiAnomalies
    };
    const jsonData = JSON.stringify(data);
    dispatch(saveApplicationResult(Id, jsonData));
  }

  useEffect(() => {
    if (props.saveApplicationResult.done) {
      Swal.fire({
        title: "Rapor kaydedildi!",
        text: "Rapor başarıyla kaydedildi.",
        icon: "success",
        confirmButtonText: "Tamam"
      });
      dispatch(resetSaveApplicationResult());
    }
  }, [props.saveApplicationResult]);

  return (
    <div>
      <Header />
      <Breadcrumb Id={Id} />
      <hr className="divide-y mt-2 " />
      <div className="pt-10 me-5 md:ml-64 ps-5">
        <h1 className="text-2xl text-start mb-3">Rapor oluştur</h1>
        <hr className="divide-y mt-2" />
        <div className="flex w-full space-x-4">
          <div className="mb-5 flex-grow w-1/2 h-screen">
            <iframe
              width="100%"
              height="100%"
              src={
                props.applicationDetail?.applicationDetail?.result?.survey
                  ?.externalId
              }
              title="Survey"
              allowFullScreen
              frameBorder="0"
            />
          </div>
          <div className="grid gap-10 flex-grow w-1/2">
            <div>
              <TextArea
                label={`Doktor ${user?.name + " " + user?.lastName} Hakkında`}
                value={about}
                onChange={(e) => {
                  setIsSave(false);
                  setAbout(e.target.value);
                }}
                rows={6}
                placeholder="Doktor özgeçmişi"
              />
            </div>
            <div>
              <TextArea
                label="Hastanın Tıbbi Geçmişinin Öyküsü"
                value={patientMedicalHistory}
                onChange={(e) => {
                  setIsSave(false);
                  setPatientMedicalHistory(e.target.value);
                }}
                rows={10}
                placeholder="Hastanın tıbbi geçmişinin öyküsü"
              />
            </div>
            <div>
              <TextArea
                label="Hastalığa İlişkin Bilgilendirme"
                value={informationOnDisease}
                onChange={(e) => {
                  setIsSave(false);
                  setInformationOnDisease(e.target.value);
                }}
                rows={10}
                placeholder="Hastalığa ilişkin bilgilendirme"
              />
            </div>
          </div>
        </div>
        <div>
          <TextArea
            label="Hastanın Radyolojik Anomalileri"
            value={radyolojiAnomalies}
            onChange={(e) => {
              setIsSave(false);
              setRadyolojiAnomalies(e.target.value);
            }}
            rows={10}
            placeholder="Hastanın radyolojik anomalileri"
          />
        </div>
        <div>
          <TextArea
            label="Hastanın Laboratuvar Anomalileri"
            value={labAnomalies}
            onChange={(e) => {
              setIsSave(false);
              setLabAnomalies(e.target.value);
            }}
            rows={10}
            placeholder="Hastanın laboratuvar anomalileri"
          />
        </div>
        <div>
          <h1 className="flex font-bold text-start justify-start">
            Hastanın Sorduğu Sorular
          </h1>
          {patientQuestions &&
            soruCevapYorumlar.map((item, index) => (
              <QuestionInput
                key={index}
                question={item.soru}
                answer={item.cevap}
                doctorComment={item.doktorYorumu}
                onChange={handleYorumChange}
                index={index}
              />
            ))}
          <TextArea
            label={`Doktor ${
              user?.name + " " + user?.lastName
            } Yorum ve Önerileri`}
            value={doctorsOpinion}
            onChange={(e) => {
              setIsSave(false);
              setDoctorsOpinion(e.target.value);
            }}
            rows={15}
            placeholder="Doktor yorum ve önerileri"
          />
        </div>
        <div className="flex justify-end mt-5">
          {props.concludeApplication.spinner ? (
            <button
              type="button"
              style={{ backgroundColor: `#09C35C` }}
              className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
            >
              <span
                className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full"
                role="status"
                aria-label="loading"
              ></span>
              Rapor Oluşturuluyor
            </button>
          ) : (
            <>
              <button
                onClick={handleSaveReport}
                className="mb-5 ml-4 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              >
                Raporu Kaydet
              </button>
              <button
                onClick={handlePreviewReport}
                className="mb-5 py-3 ml-3 px-4 inline-flex justify-center text-white items-center gap-2 rounded-md border border-transparent font-semibold bg-[#09C35C] text-white hover:bg-[#0adf6a] text-sm"
              >
                Raporu Önizle ve Onayla
              </button>
            </>
          )}
        </div>
      </div>
      <ModalPreview
        isOpen={isPreviewModalOpen}
        onRequestClose={() => setIsPreviewModalOpen(false)}
        base64Pdf={base64Pdf}
        handleCreateReport={handleCreateReport}
      />
    </div>
  );
}

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(CreateApplicationReport);
